import type { Role } from "prisma-db/prisma/generated/portal-db";

const LABELS: Record<Role, string> = {
  ADMIN: "Administrator",
  INTERNAL: "Internal",
  CUSTOMER: "Customer",
  USER: "User",
};

export function roleLabel(role: Role | undefined): string {
  return role ? (LABELS[role] ?? role) : "";
}
